import { RouteRecordRaw } from 'vue-router';

const Layout = () => import('@/layout/index.vue');
const productionRouter:RouteRecordRaw =  {
    path: '/production',
    component: Layout,
    redirect: '/production/ar-virtual',
    name: 'production',
    children: [
        {
            path: 'ai-universal',
            name: 'production-aiUniversal', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/production/ai-universal/index.vue'),
            meta: {
                title: 'AI通用产品'
            }
        },
        {
            path: 'ai-creativity',
            name: 'production-aiCreativity', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/production/ai-creativity/index.vue'),
            meta: {
                title: 'AI创新创意'
            }
        },
        {
            path: 'ai-hardware',
            name: 'production-aiHardware', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/production/ai-hardware/index.vue'),
            meta: {
                title: '智能硬件'
            }
        },
        {
            path: 'ar-virtual',
            name: 'production-arVirtual', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/production/ar-virtual/index.vue'),
            meta: {
                title: 'AR增强现实产品'
            }
        },
        {
            path: 'immersion-solution',
            name: 'production-immersionSolution', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/production/immersion-solution/index.vue'),
            meta: {
                title: '沉浸式场景解决方案'
            }
        },
        {
            path: 'ai-hardware',
            name: 'production-aiHardware', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/production/ai-hardware/index.vue'),
            meta: {
                title: '智能硬件'
            }
        },
        {
            path: 'ai-interaction',
            name: 'production-aiInteraction', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/production/ai-interaction/index.vue'),
            meta: {
                title: '交互智能平台'
            }
        },
        {
            path: 'ai-fresh-world',
            name: 'production-aiFreshWorld',
            component: () => import('@/pages/production/ai-fresh-world/index.vue'),
            meta: {
                title: 'AI新世界'
            }
        },
        {
            path: 'ai-experience',
            name: 'production-aiExperience', // 子路由的名称必须以父路由的名称座位起始字符串，为了匹配首页导航选中状态
            component: () => import('@/pages/production/ai-experience/index.vue'),
            meta: {
                title: 'AI工具箱'
            }
        }
    ]
};

export default productionRouter;
